import { render, staticRenderFns } from "./ViewerSection.vue?vue&type=template&id=d6450ade"
import script from "./ViewerSection.vue?vue&type=script&lang=js"
export * from "./ViewerSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports